<template>
  <div>
    <!-- 历史成绩-->
    <el-card class="bg_card">
      <div slot="header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><i class="el-icon-location-outline"></i> <b>当前位置</b></el-breadcrumb-item>
          <el-breadcrumb-item>考生考试</el-breadcrumb-item>
          <el-breadcrumb-item>历史成绩</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <!--条件搜索区域-->
        <div class="search_area">
          <div class="param_area">
            <el-input v-model="queryParam.examName" clearable placeholder="输入考试名称查询"></el-input>
            <el-button type="primary" @click="queryHistoryScore()">查询</el-button>
          </div>
          <div>
            <el-pagination :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParam.pageNum" :page-size="queryParam.pageSize" :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </div>
        <!--历史成绩展示表格-->
        <el-table :data="historyScore" height="620px" border stripe :header-cell-style="{background:'#eef1f6',color:'#606266'}">
          <el-table-column type="index" width="100" label="序号" align="center"></el-table-column>
          <el-table-column prop="examId" label="考试ID" v-if="false"></el-table-column>
          <el-table-column prop="examName" label="考试名称" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="paperScore" label="考生得分" align="center"></el-table-column>
          <el-table-column prop="subjectiveScore" label="主观题得分" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.hasCorrect != '1'" style="color:#E6A23C">未批阅</span>
              <span v-else>{{scope.row.subjectiveScore}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="objectiveScore" label="客观题得分" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.hasHand != '1'" style="color:red">未交卷</span>
              <span v-else>{{scope.row.objectiveScore}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="reviewExam(scope.row)" type="info" size="small">考试回顾</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 答题回顾对话框-->
    <el-dialog width="1100px" title="答题回顾" :visible.sync="reviewExamDialogVisible" top="20px" >
        <div style="height:750px">
            <el-scrollbar style="height:100%">
                <div>
                    <h1 class="exam_name">{{examInfo.examName}}</h1>
                    <h2 class="exam_info">
                    <span>时长：{{examInfo.examDuration}}分钟</span>&nbsp;&nbsp;
                    <span>总分：{{examInfo.paper.paperScore}}分</span>&nbsp;&nbsp;
                    <span>及格分：{{examInfo.paper.passScore}}分</span>
                    </h2>
                </div>
                <div>
                    <el-card class="box-card paperCard" shadow="never" v-for="paperItem in paperDetail" :key="paperItem.partId">
                    <div slot="header" class="clearfix">
                        <span>{{paperItem.partName}}</span>
                        <el-button style="float: right; padding: 3px 0" type="text">每题：{{paperItem.questionScore}}分</el-button>
                    </div>
                    <table class="ques_table" v-for="(item, index) in paperItem.questions" :key="item.questionId">
                        <thead>
                        <tr>
                            <th class="ques_content">
                            <span class="label label-primary">{{index + 1}}</span>
                            <span class="quesDetail"> {{item.questionTitle}}</span>
                            </th>
                        </tr>
                        </thead>
                        <br><br>
                        <tfoot style="background-color:#F9F9F9">
                        <tr>
                            <td class="ques_bottom">
                                <div>
                                    <div v-if="item.typeName.indexOf('单') != -1 || item.typeName.indexOf('多') != -1">
                                        <b>试题选项：</b><span v-for="im in item.options" :key="im.optionId"><span>{{im.optionValue}}.{{im.optionLabel}}&nbsp;&nbsp;</span></span>
                                    </div>
                                    <div v-if="item.typeName.indexOf('判') != -1">
                                        <b>试题选项：</b>T.正确、F.错误
                                    </div>
                                    <div v-if="item.typeName.indexOf('单') != -1 || item.typeName.indexOf('多') != -1 || item.typeName.indexOf('判') != -1">
                                        <b>正确答案：</b>{{item.questionOption}}
                                    </div>
                                    <div v-else>
                                        <b>正确答案：</b>{{item.questionAnswer}}
                                    </div>
                                    <div v-if="item.answerScore != undefined">
                                        <div>
                                            <b>考生答案：</b>{{item.errorAnswer}}
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="item.typeName.indexOf('填') != -1 || item.typeName.indexOf('简') != -1">
                                            <b>考生答案：</b>{{item.errorAnswer}}
                                        </div>
                                        <div v-else>
                                            <b>考生答案：</b>{{item.questionOption}}
                                        </div>
                                    </div>
                                </div>
                                <el-button size="mini" class="setScoreBtn" :type="item.answerScore == 0 ? 'danger' : 'warning'" disabled v-if="item.answerScore != undefined">
                                        <b>得分: </b>{{item.answerScore}} 分
                                </el-button>
                                <el-button size="mini" class="setScoreBtn" disabled v-else type="success">
                                        <b>得分: </b>{{paperItem.questionScore}} 分
                                </el-button>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                    </el-card>
                </div>
            </el-scrollbar>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryExamResByUserId } from '../../api/examinee';
import { queryExamAndPaper, reviewExam } from '../../api/exam';
export default {
	data() {
		return {
			queryParam: {
				//查询参数
				userId: null,
				examName: null,
				orderByColumn: 'eus.update_time',
				isAsc: 'desc',
				pageNum: 1,
				pageSize: 10
			},
			totalCount: 0, //总数据条数
			historyScore: [], //历史成绩列表
			reviewExamDialogVisible: false, //回顾考试对话框显示
			examInfo: {
				//试卷信息
				paper: {}
			},
			paperScore: 0, //考试得分
			paperDetail: [] //考生答题回顾
		};
	},
	created() {
		//首先从store中取出userId
		this.queryParam.userId = JSON.parse(this.$store.state.loginInfo).userId;
		this.queryHistoryScore();
	},
	methods: {
		//根据登录人员ID分页查询历史成绩
		queryHistoryScore() {
			queryExamResByUserId(this.queryParam).then((response) => {
				if (response.data.code === 200) {
					this.totalCount = response.data.total;
					this.historyScore = response.data.rows;
					if (this.historyScore.length === 0) {
						this.$message({
							message: '未查询您的历史成绩信息！',
							type: 'warning'
						});
					}
				} else {
					this.$message({
						message: '查询出错！',
						type: 'error'
					});
				}
			});
		},
		//改变当前记录条数
		handleSizeChange(val) {
			this.queryParam.pageSize = val;
			this.queryParam.pageNum = 1;
			this.queryHistoryScore();
		},
		//改变当前页码，重新发送请求
		handleCurrentChange(val) {
			this.queryParam.pageNum = val;
			this.queryHistoryScore();
		},
		//回顾考试
		reviewExam(row) {
			const param = {
				examId: row.examId,
				userId: this.queryParam.userId
			};
			queryExamAndPaper(param).then((res) => {
				if (res.data.code === 200) {
					this.examInfo = res.data.data;
				} else {
					this.$message({
						message: res.data.msg,
						type: 'error'
					});
				}
			});
			reviewExam(param).then((res) => {
				//console.log(res);
				if (res.data.code === 200) {
					this.reviewExamDialogVisible = true;
					this.currentPaperInfo = res.data.data;
					this.paperDetail = this.currentPaperInfo.examPartList;
				} else {
					this.$message({
						message: res.data.msg,
						type: 'error'
					});
				}
			});
		}
	}
};
</script>
<style lang="less" scoped>
.bg_card {
	width: 1672px;
        position: fixed;
        height: 90vh;
	.search_area {
		.param_area {
			display: flex;
			.el-input {
				margin-right: 10px;
			}
		}
		margin-bottom: 10px;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
	}
}
.el-dialog {
	.exam_name {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
		margin: 0 auto 20px auto;
	}
	.exam_info {
		font-size: 12px;
		font-weight: normal;
		text-align: center;
		color: #000;
		margin: 20px auto;
		span {
			background-color: #f5f5f5;
			color: #000;
			font-weight: normal;
			padding: 5px 10px !important;
		}
	}
	.paperCard {
		margin-bottom: 10px;
	}
	.ques_table {
		width: 100%;
		// border: 1px solid #d6d3d3;
		margin-bottom: 10px;
		tr {
			min-height: 25px;
		}
		.ques_content {
			text-align: left;
			//width:10px;
			padding-top: 5px;
			.label {
				color: #fff;
				font-size: 100%;
				white-space: nowrap;
				display: inline;
				padding: 0.2em 0.6em 0.3em;
				font-weight: 700;
				line-height: 1;
				text-align: center;
				white-space: nowrap;
				vertical-align: baseline;
				border-radius: 0.25em;
			}
			.label-primary {
				background-color: #1e88e5;
			}
		}
		.ques_bottom {
			display: flex;
			align-items: center;
			justify-content: space-between;
            .setScoreBtn {
                height: 100%;
                //border: 1px solid #6e6c6c;
                color: #2c2929 !important;
            }
		}
	}
}
</style>
